import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Collapse, Card, CardBody, CardTitle, Table } from 'reactstrap';
import _ from 'lodash';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import Translate, { t } from '../../common/Translate';
import { vehiclePresenter } from '../../../Utils/presenters/vincheck/vehiclePresenter';

const VehicleBloc = (vincheck) => {
  const [vehicle] = useState(_.get(vincheck, `vehicle`, null));
  const [isBlocOpen, setIsBlocOpen] = useState(true);
  const toggleBloc = () => setIsBlocOpen(!isBlocOpen);

  useEffect(() => {
    vehiclePresenter(vehicle);
  }, [vehicle]);

  return (
    <Card className="card-window mt-4 mr-3 ml-4">
      <CardTitle>
        <Translate code="vehicle" />
        <FontAwesomeIcon
          className="text-corrected float-right"
          onClick={toggleBloc}
          icon={isBlocOpen ? faChevronUp : faChevronDown}
        />
      </CardTitle>
      <Collapse isOpen={isBlocOpen}>
        <CardBody>
          {vehicle && (
            <div>
              <div className="text-center mb-2 font-weight-bold">{vehicle.title}</div>
              <Table striped>
                <tbody>
                  <tr>
                    <td className="font-weight-bold">{t('registration_plate')}</td>
                    <td>{vehicle.registration}</td>
                    <td className="font-weight-bold">{t('vin_number')}</td>
                    <td>{vehicle.vin}</td>
                    <td className="font-weight-bold">{t('vehicule_type')}</td>
                    <td>{vehicle.vehicleTypeCode}</td>
                  </tr>

                  <tr>
                    <td className="font-weight-bold">{t('observed_mileage')}</td>
                    <td>{vehicle.mileage} km</td>
                    <td className="font-weight-bold">{t('standard_mileage')}</td>
                    <td>------------</td>
                    <td className="font-weight-bold">{t('mileage_difference')}</td>
                    <td>------------</td>
                  </tr>

                  <tr>
                    <td className="font-weight-bold">{t('b2c_mileage')}</td>
                    <td>------------</td>
                    <td className="font-weight-bold">{t('doors')}</td>
                    <td>{vehicle.door}</td>
                    <td className="font-weight-bold">{t('seats')}</td>
                    <td>{vehicle.seat}</td>
                  </tr>

                  <tr>
                    <td className="font-weight-bold">{t('dateGrayCard')}</td>
                    <td>{vehicle.grayCardDateFormated}</td>
                    <td className="font-weight-bold">{t('dateOfRelease')}</td>
                    <td>{vehicle.releaseDateFormated}</td>
                    <td className="font-weight-bold">{t('dateOfProduction')}</td>
                    <td>{vehicle.productionDateFormated}</td>
                  </tr>

                  <tr>
                    <td className="font-weight-bold">{t('hand')}</td>
                    <td>{vehicle.Owner}</td>
                    <td className="font-weight-bold">{t('current_owner_since')}</td>
                    <td>{vehicle.releaseDateFormated}</td>
                    <td className="font-weight-bold">{t('hand')}</td>
                    <td>{vehicle.productionDateFormated}</td>
                  </tr>
                </tbody>
              </Table>
            </div>
          )}
        </CardBody>
      </Collapse>
    </Card>
  );
};

export default VehicleBloc;
